<template>
  <q-page class="container" padding>
    <PageHeader
      title="Cadastrar Parceiro"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md items-center"
      >
        <div class="col-md-2 col-sm-12 col-xs-12">
          <div>Unidade</div>
          <ListaUnidadesSelect class="input-new-design" />
        </div>
        <div>
          <p></p>
          <q-btn
            class="q-mt-xs"
            label="Cadastrar"
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
            no-caps
            @click="rightDrawerOpen = true"
            icon="done"
          />
        </div>
      </div>
    </div>

    <div class="q-mt-xl">
      <div class="q-mt-lg">
        <q-table
          table-header-class="bg-accent text-weight-bold"
          :rows="listaParceiros"
          :columns="columns"
          :rows-per-page-options="[0]"
          dense
          class="tabela-tamanho-fixo"
          :loading="loading"
          hide-bottom
          flat
          color="primary"
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Empresas / Parceiros Cadastrados</span
            >
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="parceiroId" :props="props">{{
                props.row.parceiroId
              }}</q-td>
              <q-td class="text-left" key="cnpj" :props="props">{{
                props.row.cnpj
              }}</q-td>
              <q-td class="text-left" key="nome" :props="props">{{
                props.row.nome
              }}</q-td>
              <q-td class="center" key="editar" :props="props">
                <q-btn
                  icon="sym_o_edit"
                  flat
                  color="primary"
                  dense
                  no-caps
                  @click="
                    (rightDrawerOpen = true),
                      (editarParceiro = true),
                      (dadoEditar = { ...props.row }),
                      (nomeParceiroEditar = props.row.nome)
                  "
                />
              </q-td>
              <q-td class="center" key="nome" :props="props">
                <q-btn
                  icon="sym_o_delete"
                  flat
                  color="red"
                  dense
                  no-caps
                  @click="
                    (deleteId = props.row.parceiroId),
                      (confirmacao = !confirmacao)
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span class="texto-titulo-modal">
              {{
                editarParceiro
                  ? `Editar: ${nomeParceiroEditar}`
                  : "Cadastrar Empresa/Parceiro"
              }}
            </span>
          </div>
        </div>
        <q-scroll-area v-if="!editarParceiro" style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Nome</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="parceiro.nome"
                  dense
                  outlined
                  autocomplete="off"
                  maxlength="100"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">CNPJ</div>
                <q-input
                  class="input-modal input-new-design"
                  mask="##.###.###/####-##"
                  unmasked-value
                  fill-mask
                  v-model="parceiro.cnpj"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Razão Social</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="parceiro.razaoSocial"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Inscrição Estadual</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="parceiro.inscricaoEstadual"
                  dense
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">CEP</div>
                <q-input
                  class="input-modal input-new-design"
                  mask="#####-###"
                  unmasked-value
                  fill-mask
                  dense
                  outlined
                  debounce="1000"
                  autocomplete="off"
                  v-model="parceiro.cep"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Bairro</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="endereco.bairro"
                  dense
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Rua</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="endereco.rua"
                  dense
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Numero</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="parceiro.numero"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Cidade</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="endereco.cidade"
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  dense
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Estado</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="endereco.estado"
                  dense
                  maxlength="2"
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  autocomplete="off"
                  outlined
                />
              </div>
            </div>
            <div style="margin-top: 24px" class="q-px-md">
              <q-btn
                label="Cadastrar"
                style="
                  background-color: #21324a;
                  border-radius: 8px;
                  color: white;
                "
                no-caps
                icon="done"
                @click="criar()"
              />
            </div>
          </div>
        </q-scroll-area>
        <q-scroll-area v-else style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Nome</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.nome"
                  dense
                  outlined
                  maxlength="100"
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">CNPJ</div>
                <q-input
                  class="input-modal input-new-design"
                  mask="##.###.###/####-##"
                  unmasked-value
                  fill-mask
                  autocomplete="off"
                  v-model="dadoEditar.cnpj"
                  dense
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Razão Social</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.razaoSocial"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Inscrição Estadual</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.inscricaoEstadual"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">CEP</div>
                <q-input
                  class="input-modal input-new-design"
                  mask="#####-###"
                  unmasked-value
                  fill-mask
                  autocomplete="off"
                  dense
                  outlined
                  debounce="1000"
                  v-model="dadoEditar.cep"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Rua</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.rua"
                  dense
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Bairro</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.bairro"
                  dense
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Numero</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.numero"
                  dense
                  autocomplete="off"
                  outlined
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Cidade</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.cidade"
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  dense
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Estado</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="dadoEditar.estado"
                  dense
                  maxlength="2"
                  :bg-color="disableEndereco ? 'brand-7' : ''"
                  :disable="disableEndereco"
                  outlined
                  autocomplete="off"
                />
              </div>
            </div>
            <div style="margin-bottom: 44px; margin-top: 24px" class="q-px-md">
              <q-btn
                label="Salvar"
                style="
                  background-color: #21324a;
                  border-radius: 8px;
                  color: white;
                "
                no-caps
                icon="done"
                @click="editar()"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir a Empresa / Parceiro?"
      :exibir="confirmacao"
      @resultado="removerParceiro"
    />
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  name: "CadastrarParceiro",
  components: { ListaUnidadesSelect, DialogConfirmDesign, PageHeader },
  setup() {
    const store = useStore();

    const parceiro = ref({
      parceiroId: "",
      cnpj: "",
      nome: "",
      razaoSocial: "",
      inscricaoEstadual: "",
      numero: "",
      cep: "",
    });
    const endereco = ref({
      rua: "",
      cidade: "",
      estado: "",
    });
    const unidade = ref({});
    const listaParceiros = ref([]);
    let rightDrawerOpen = ref(false);
    const loading = ref(false);
    const $q = useQuasar();
    const confirmacao = ref(false);
    const deleteId = ref(null);
    const myForm = ref(null);
    let disableEndereco = ref(false);
    let editarParceiro = ref(false);
    const dadoEditar = ref({});
    let nomeParceiroEditar = ref("");
    const columns = [
      {
        name: "parceiroId",
        label: "ID",
        field: "parceiroId",
        align: "left",
        sortable: true,
      },
      {
        name: "cnpj",
        label: "CNPJ",
        field: "cnpj",
        align: "left",
        sortable: true,
      },
      {
        name: "nome",
        label: "Nome",
        field: "nome",
        align: "left",
        sortable: true,
      },
      {
        name: "editar",
        label: "Editar",
        align: "left",
      },
      {
        name: "remover",
        label: "Remover",
        align: "left",
      },
    ];

    const listarParceiros = async () => {
      await unidade.value.id;
      loading.value = true;
      try {
        let response = await store.dispatch("ter/listarParceiros", {
          unidadeId: unidade.value.id,
        });
        listaParceiros.value = response.response.data.resultado.dados;
        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const criar = async () => {
      try {
        await store.dispatch("ter/criarParceiro", {
          nome: parceiro.value.nome,
          cnpj: parceiro.value.cnpj,
          unidadeId: unidade.value.id,
          razaoSocial: parceiro.value.razaoSocial,
          inscricaoEstadual: parceiro.value.inscricaoEstadual,
          rua: endereco.value.rua,
          numero: parceiro.value.numero,
          cidade: endereco.value.cidade,
          estado: endereco.value.estado,
          bairro: endereco.value.bairro,
          cep: parceiro.value.cep,
        });

        $q.notify({
          message: "Parceiro cadastrado.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        onReset();
        listarParceiros();
      } catch (e) {
        if (e.response?.data.erro?.detalhes) {
          for (let index in e.response?.data.erro?.detalhes) {
            $q.notify({
              message: `${index}: ${e.response?.data.erro?.detalhes[index][0]}`,
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const editar = async () => {
      try {
        await store.dispatch("ter/editarParceiro", {
          parceiroId: dadoEditar.value.parceiroId,
          nome: dadoEditar.value.nome,
          cnpj: dadoEditar.value.cnpj,
          unidadeId: unidade.value.id,
          razaoSocial: dadoEditar.value.razaoSocial,
          inscricaoEstadual: dadoEditar.value.inscricaoEstadual,
          rua: dadoEditar.value.rua,
          numero: dadoEditar.value.numero,
          cidade: dadoEditar.value.cidade,
          bairro: dadoEditar.value.bairro,
          estado: dadoEditar.value.estado,
          cep: dadoEditar.value.cep,
        });

        $q.notify({
          message: "Parceiro editado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        listarParceiros();
      } catch (e) {
        if (e.response?.data.erro?.detalhes) {
          for (let index in e.response?.data.erro?.detalhes) {
            $q.notify({
              message: `${index}: ${e.response?.data.erro?.detalhes[index][0]}`,
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          }
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const removerParceiro = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          await store.dispatch("ter/removerParceiro", {
            parceiroId: deleteId.value,
            unidadeId: unidade.value.id,
          });
          $q.notify({
            message: "Parceiro removido com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listarParceiros();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao remover parceiro",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const onReset = async () => {
      await reset();
      myForm.value.resetValidation();
    };

    const reset = async () => {
      parceiro.value = {
        parceiroId: "",
        cnpj: "",
        nome: "",
        razaoSocial: "",
        inscricaoEstadual: "",
      };
      endereco.value = {
        rua: "",
        cidade: "",
        estado: "",
        bairro: "",
      };
      dadoEditar.value = {};
      rightDrawerOpen.value = false;
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      listarParceiros();
    };

    const verificarCep = async () => {
      disableEndereco.value = true;
      try {
        const response = await store.dispatch("ter/verificarCep", {
          cep: parceiro.value.cep || dadoEditar.value?.cep,
        });
        let value = response.data;
        if (value && !editarParceiro.value) {
          endereco.value = {
            rua: value?.logradouro,
            cidade: value?.localidade,
            estado: value.uf,
            bairro: value?.bairro,
          };
        } else {
          dadoEditar.value.rua = value?.logradouro;
          dadoEditar.value.cidade = value?.localidade;
          dadoEditar.value.estado = value?.uf;
        }
        disableEndereco.value = false;
      } catch (error) {
        console.log(error);
        disableEndereco.value = false;
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        listarParceiros();
      }
    );

    watch([() => parceiro.value.cep, () => dadoEditar.value?.cep], () => {
      if (
        parceiro.value.cep?.length == 8 ||
        dadoEditar.value?.cep?.length == 8
      ) {
        verificarCep();
      }
    });

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (!rightDrawerOpen.value) {
          editarParceiro.value = false;
          dadoEditar.value = {};
        }
      }
    );

    onMounted(getUnidade);

    return {
      parceiro,
      criar,
      myForm,
      listaParceiros,
      listarParceiros,
      columns,
      removerParceiro,
      getUnidade,
      unidade,
      loading,
      rightDrawerOpen,
      verificarCep,
      endereco,
      disableEndereco,
      dadoEditar,
      editar,
      editarParceiro,
      nomeParceiroEditar,
      confirmacao,
      deleteId,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.titulo-tabela {
  font-size: 18px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.texto-titulo-modal {
  font-size: 16px;
  color: #21324a;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}

/* Media queries específicas para dispositivos móveis */
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 90%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(100vw);
  }

  /* Ajuste do cabeçalho do modal para mobile */
  .drawer-modal .q-pa-md:first-child {
    padding-bottom: 10px !important;
  }

  /* Ajuste da área de scroll para mobile */
  .drawer-modal .q-scroll-area {
    height: calc(100vh - 80px) !important;
    padding-top: 20px !important;
  }

  /* Garante que o conteúdo não seja cortado */
  .drawer-modal .q-px-md {
    padding-top: 20px !important;
  }

  .container-modal {
    padding-bottom: 10px !important;
  }

  .texto-titulo-modal {
    font-size: 14px;
  }

  /* Melhora a visualização do botão de fechar */
  .drawer-modal .q-icon {
    padding: 8px !important;
  }
}

@media (max-width: 480px) {
  .drawer-modal {
    max-height: 90%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
  }

  .drawer-modal .q-pa-md {
    padding: 16px !important;
  }

  .drawer-modal .q-px-md {
    padding-left: 16px !important;
    padding-right: 16px !important;
    padding-top: 20px !important;
  }

  .drawer-modal .q-scroll-area {
    height: calc(100vh - 70px) !important;
  }

  .input-modal {
    margin-bottom: 12px;
  }

  .texto-titulo-input {
    font-size: 13px;
    margin-bottom: 6px;
    font-weight: 600;
  }

  .texto-titulo-modal {
    font-size: 13px;
    line-height: 1.2;
  }
}

@media (max-width: 360px) {
  .drawer-modal {
    max-height: 70%;
    max-width: 100%;
    margin-top: 5%;
    overflow: hidden;
  }

  .drawer-modal .q-pa-md {
    padding: 12px !important;
  }

  .drawer-modal .q-px-md {
    padding-left: 12px !important;
    padding-right: 12px !important;
    padding-top: 16px !important;
  }

  .drawer-modal .q-scroll-area {
    height: calc(100vh - 60px) !important;
  }

  .texto-titulo-modal {
    font-size: 12px;
    line-height: 1.1;
  }

  .texto-titulo-input {
    font-size: 12px;
    margin-bottom: 4px;
    font-weight: 600;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
